/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type IntegrationOnlineMeetingResponse = {
    id: number;
    joinUrl: string;
    provider: IntegrationOnlineMeetingResponse.provider;
};
export namespace IntegrationOnlineMeetingResponse {
    export enum provider {
        ZOOM = 'zoom',
        MICROSOFT_TEAMS = 'microsoft-teams',
        TEBUTO_MEET = 'tebuto-meet',
    }
}

